import { DEFAULT_CURRENCY, LOCALE } from '@/lib/constants/i18n';

export const formatPrice = (
  value: number = 0,
  currency: string = DEFAULT_CURRENCY,
  locale: LOCALE | undefined = undefined,
) =>
  new Intl.NumberFormat(locale, {
    currency,
    minimumFractionDigits: 0,
    style: 'currency',
  }).format(value);
